export const ACCOUNT_SCORE_LOW_MARK = 29;
export const ACCOUNT_SCORE_HIGH_MARK = 49;
